import { TABLES } from "../db";
import { BaseLocalRepository } from "./BaseLocalRepository";

export class LocalVesselParticularsRepository extends BaseLocalRepository {
  constructor(db) {
    super(db, TABLES.VESSEL_PARTICULARS);
  }
}
